import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  Menu,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  addSupplierNote,
  deleteSupplierNoteApi,
  getSupplierNotesListApi,
  updateSupplierNoteApi,
} from "../../../redux/Supplier/action";
import SuccessMessageModal from "../../Common/SuccessMessage";

function SupplierNotes(props) {
  const { id, type } = useParams();
  const dispatch = useDispatch();
  const [newNote, setNewNote] = useState("");
  const [noteError, setNoteError] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [editDeleteNoteId, setEditDeleteNoteId] = useState("");
  const [editNoteText, setEditNoteText] = useState("");
  const [selectedActionOfNote, setSelectedActionOfNote] = useState("");

  const [anchorElAtions, setAnchorElActions] = React.useState(null);
  const openNoteActions = Boolean(anchorElAtions);

  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [successMessageType, setSuccessMessageType] = useState("success");

  const noteList = useSelector((state) => state.supplier?.noteList?.data);

  useEffect(() => {
    fetchSupplierNots();
  }, []);

  const fetchSupplierNots = async () => {
    const params = {
      supplier: id,
    };
    await dispatch(getSupplierNotesListApi(params));
  };

  const handleClickNoteActions = (event, data) => {
    setSelectedActionOfNote(data);
    setAnchorElActions(event.currentTarget);
  };

  const handleCloseNoteActions = () => {
    setAnchorElActions(null);
    setSelectedActionOfNote("");
  };

  const handleUpdateNote = async () => {
    let payload = { note: editNoteText };
    setShowLoader(true);
    await dispatch(updateSupplierNoteApi(editDeleteNoteId?._id, payload));
    fetchSupplierNots();
    setEditDeleteNoteId("");
    setEditNoteText("");
    setShowLoader(false);
    setOpenSuccessModal(true);
    setSuccessMessage("Note Updated");
  };

  const handleDeleteNote = async (id) => {
    setShowLoader(true);
    await dispatch(deleteSupplierNoteApi(id));
    fetchSupplierNots();
    setEditDeleteNoteId("");
    setEditNoteText("");
    setShowLoader(false);
    setOpenSuccessModal(true);
    setSuccessMessage("Note Deleted");
  };

  const handleAddNote = async () => {
    if (!newNote) {
      return setNoteError(true);
    }
    setNoteError(false);

    let payload = {
      supplierId: id,
      note: newNote,
    };
    const resp = await dispatch(addSupplierNote(payload));
    setNewNote("");
    if (resp) {
      fetchSupplierNots();
      setOpenSuccessModal(true);
      setSuccessMessage("Note Added");
    }
  };

  return (
    <Grid
      container
      item
      xs={12}
      sm={12}
      md={12}
      xl={12}
      justifyContent={"space-between"}
      borderRadius={"4px"}
      mt={"16px"}
    >
      <Grid container justifyContent={"start"} borderTop={"none"}>
        <Grid container item xs={12} sm={12} md={12} xl={12} rowGap={3}>
          <Stack spacing={2} sx={{ width: "100%", padding: "16px" }}>
            <Grid item xs={12} sm={12} md={12} xl={12} padding={""}>
              <Typography
                variant="h6"
                sx={{ fontWeight: 500, marginBottom: "16px" }}
              >
                Recent Notes
              </Typography>
            </Grid>
            <Grid container item xs={12} sm={12} md={12} xl={12}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                fullWidth
                type="text"
                value={newNote}
                onChange={(e) => setNewNote(e.target.value)}
              />
            </Grid>
            {noteError && (
              <p
                style={{
                  color: "#d32f2f",
                  fontSize: "0.75rem",
                  letterSpacing: "0.03333em",
                  lineHeight: "1.66",
                  marginTop: "3px",
                }}
              >
                Please enter note
              </p>
            )}
            <Grid
              container
              xs={12}
              sm={12}
              md={12}
              xl={12}
              justifyContent={"end"}
            >
              <Grid>
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  onClick={handleAddNote}
                >
                  Add Note
                </Button>
              </Grid>
            </Grid>
          </Stack>

          <Grid item container>
            {Array.isArray(noteList) &&
              noteList?.map((data) => {
                return (
                  <Grid
                    container
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}
                    style={{
                      backgroundColor: "#e6f7f7",
                      borderRadius: "8px",
                      padding: "16px",
                      marginBottom: "24px",
                    }}
                    display={"block"}
                  >
                    <Stack
                      direction={"row"}
                      justifyContent={"space-between"}
                      mb={2}
                    >
                      <div>
                        <Typography variant="body1">
                          {dayjs(data?.createdAt).format("MMMM DD, YYYY") +
                            " at " +
                            dayjs(data?.createdAt).format("h:mm A")}
                        </Typography>
                      </div>

                      <div style={{ marginRight: "16px" }}>
                        <Button
                          variant="contained"
                          onClick={(e) => {
                            handleClickNoteActions(e, data);
                          }}
                          id={data?._id}
                          aria-controls={
                            openNoteActions ? "demo-positioned-menu" : undefined
                          }
                          aria-haspopup="true"
                          aria-expanded={openNoteActions ? "true" : undefined}
                          endIcon={<ExpandMoreIcon />}
                        >
                          Actions
                        </Button>
                        <Menu
                          style={{ width: "300px" }}
                          id="demo-positioned-menu"
                          aria-labelledby={data?._id}
                          anchorEl={anchorElAtions}
                          open={openNoteActions}
                          onClose={handleCloseNoteActions}
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "left",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                          }}
                        >
                          <MenuItem
                            onClick={() => {
                              handleCloseNoteActions();
                              setEditDeleteNoteId(selectedActionOfNote);
                              setEditNoteText(selectedActionOfNote?.note);
                            }}
                          >
                            {" "}
                            <EditIcon style={{ marginRight: "10px" }} /> Edit
                            Note
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              handleCloseNoteActions();
                              handleDeleteNote(selectedActionOfNote?._id);
                            }}
                          >
                            {" "}
                            <DeleteIcon style={{ marginRight: "10px" }} />{" "}
                            Delete Note
                          </MenuItem>
                        </Menu>
                      </div>
                    </Stack>
                    {editDeleteNoteId?._id != data._id && (
                      <Card
                        style={{
                          backgroundColor: "#fff",
                          padding: "10px",
                          marginRight: "10px",
                          marginBottom: "8px",
                          border: "1px solid #C4C4C4",
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: 400,
                            fontSize: "16px",
                          }}
                        >
                          {data?.note}
                        </Typography>
                      </Card>
                    )}
                    {editDeleteNoteId && editDeleteNoteId?._id == data?._id && (
                      <>
                        <TextField
                          style={{
                            backgroundColor: "#fff",
                            marginRight: "10px",
                            marginBottom: "16px",
                            width: "100%",
                          }}
                          value={editNoteText}
                          onChange={(e) => setEditNoteText(e.target.value)}
                        />
                        <Button
                          variant="contained"
                          style={{ marginRight: "16px" }}
                          onClick={() => handleUpdateNote()}
                        >
                          SAVE
                        </Button>
                        <Button
                          variant="outlined"
                          onClick={() => {
                            setEditDeleteNoteId("");
                            setSelectedActionOfNote("");
                          }}
                        >
                          CANCEL
                        </Button>
                      </>
                    )}
                  </Grid>
                );
              })}
          </Grid>
        </Grid>
      </Grid>
      <SuccessMessageModal
        message={successMessage}
        open={openSuccessModal}
        setOpenSuccessModal={setOpenSuccessModal}
        alertType={successMessageType}
      />
      <Dialog open={showLoader}>
        <DialogContent>
          <CircularProgress />
        </DialogContent>
      </Dialog>
    </Grid>
  );
}

export default SupplierNotes;
